import { useState } from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import PurchaseRewardPromotionsList from './PurchaseRewardPromotionsList';
import PurchaseRewardExclusionsList from '../PurchaseRewardExclusions/PurchaseRewardExclusionsList';

const PurchaseRewardPromotions = () => {
    const [tabIndex, setTabIndex] = useState<number>(0);

    return (
        <>
            <Tabs
                index={tabIndex}
                onChange={setTabIndex}
            >
                <TabList
                    margin='0 20px 0px 20px'
                    borderColor='#343847'
                    position='relative'
                    sx={{
                        '&::-webkit-scrollbar': {
                            display: 'none !important'
                        },
                        overflowX: 'auto !important',
                        overflowY: 'hidden !important',
                    }}
                >
                    <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
                        Promociones de Recompensa
                    </Tab>
                    <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
                        Productos Excluidos
                    </Tab>
                </TabList>

                <TabPanels p='0'>
                    <TabPanel p='0'>
                        <PurchaseRewardPromotionsList />
                    </TabPanel>
                    <TabPanel p='0'>
                        <PurchaseRewardExclusionsList />
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </>
    );
}

export default PurchaseRewardPromotions;
